/* batida-v7-searchpage.js (7.10): the search results page of batida.pl (sections/batida-v7-search-main.liquid).
   - phones: the filter panel opens/closes (the category pages' toggle, assets/batida-v7-collection.js, is not loaded here)
   - sort + price fields: send their form when changed (without the script a small "OK" button does it)
   Nothing else; the filters themselves are plain links with their own URLs. */
(function () {
  'use strict';
  function init() {
    var filt = document.querySelector('[data-v7s-filt]');
    var tgl = filt && filt.querySelector('[data-v7s-filt-toggle]');
    if (tgl && !tgl.hasAttribute('data-v7s-ready')) {
      tgl.setAttribute('data-v7s-ready', '1');
      tgl.addEventListener('click', function () {
        var on = !filt.classList.contains('is-open');
        filt.classList.toggle('is-open', on);
        tgl.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
    var sort = document.querySelector('[data-v7s-sort-select]');
    if (sort && !sort.hasAttribute('data-v7s-ready')) {
      sort.setAttribute('data-v7s-ready', '1');
      sort.addEventListener('change', function () { if (sort.form) sort.form.submit(); });
    }
    document.querySelectorAll('[data-v7s-price]').forEach(function (f) {
      if (f.hasAttribute('data-v7s-ready')) return;
      f.setAttribute('data-v7s-ready', '1');
      f.querySelectorAll('input[type="number"]').forEach(function (i) {
        i.addEventListener('change', function () { f.submit(); });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
